// RBAC + Arabic labels — mirrors backend/adminc/deps.py
export const ROLE_AR = {
  super_admin: "مالك المنصة",
  admin: "مدير المنصة",
  employee: "موظف — دون صلاحية إدارية",
};
export const PERMS = {
  super_admin: ["*"],
  admin: ["view_admin", "manage_users", "manage_content", "view_reports", "export_reports", "view_audit", "manage_settings",
          "manage_roles", "view_overview", "view_users", "view_dept", "view_dept_reports", "export_dept_reports"],
  employee: [],
};
const SUPERVISION = ["view_supervision", "view_overview", "view_users", "view_reports", "export_reports", "view_dept", "view_dept_reports", "export_dept_reports"];
export const can = (user, perm) => {
  if (!user || user.active === false || (user.approval_status || "approved") !== "approved") return false;
  const p = PERMS[user.role] || [];
  return p.includes("*") || p.includes(perm) || (!!user.supervision && SUPERVISION.includes(perm));
};
export const isAdminUser = user => can(user, "view_admin");
export const isDeptManager = user => can(user, "view_supervision") && !isAdminUser(user);

export const APPROVAL_AR = {
  onboarding: "لم يكمل الإعداد", pending: "قيد المراجعة", approved: "معتمد",
  rejected: "مرفوض", suspended: "معلّق",
};
export const APPROVAL_TONE = {
  onboarding: "muted", pending: "gold", approved: "emerald", rejected: "red", suspended: "red",
};


export const CH_STATUS_AR = {
  draft: "مسودة", active: "مفعّل", scheduled: "مجدول", locked: "مقفل",
  disabled: "موقوف", archived: "مؤرشف",
};
export const CH_STATUS_TONE = {
  draft: "muted", active: "emerald", scheduled: "gold", locked: "gold", disabled: "red", archived: "muted",
};
export const VIDEO_STATUS_AR = { active: "مفعّل", disabled: "موقوف", locked: "مقفل", scheduled: "مجدول" };
export const Q_TYPE_AR = {
  mcq: "اختيار من متعدد", multi: "متعدد الاختيارات", truefalse: "صح أو خطأ",
  text: "إجابة نصية قصيرة", task: "إجابة نصية طويلة", scenario: "سؤال موقف", ordering: "ترتيب عناصر",
  matching: "توصيل العناصر", hotspot: "اكتشف الخطأ في الصورة", formula_fix: "صحّح الصيغة أو الكود",
};
